/* Contrail theme scripts — progressive enhancement only. Every form works without JS. */
(function () {
  'use strict';

  var theme = window.theme || { routes: {}, strings: {} };
  var routes = theme.routes;
  var strings = theme.strings;

  function qsa(selector, root) {
    return Array.prototype.slice.call((root || document).querySelectorAll(selector));
  }

  function fetchJSON(url, options) {
    return fetch(url, options).then(function (response) {
      return response.json().then(function (data) {
        if (!response.ok) {
          var error = new Error(data.description || data.message || strings.cartError);
          error.data = data;
          throw error;
        }
        return data;
      });
    });
  }

  function updateCartCount(count) {
    qsa('[data-cart-count]').forEach(function (el) { el.textContent = count; });
    qsa('[data-cart-bubble]').forEach(function (el) { el.hidden = count < 1; });
    qsa('[data-cart-link]').forEach(function (el) {
      var template = count === 1 ? el.dataset.labelOne : el.dataset.labelOther;
      if (template) el.setAttribute('aria-label', template.replace('[count]', count));
    });
  }

  /* ---------------------------------------------------------------
     Quantity input (+ / −)
     --------------------------------------------------------------- */
  if (!customElements.get('quantity-input')) {
    customElements.define('quantity-input', class extends HTMLElement {
      connectedCallback() {
        this.input = this.querySelector('input');
        this.minus = this.querySelector('[name="minus"]');
        this.plus = this.querySelector('[name="plus"]');
        var self = this;
        [this.minus, this.plus].forEach(function (button) {
          if (!button) return;
          button.addEventListener('click', function (event) {
            event.preventDefault();
            var previous = self.input.value;
            if (button === self.plus) self.input.stepUp(); else self.input.stepDown();
            if (previous !== self.input.value) {
              self.input.dispatchEvent(new Event('change', { bubbles: true }));
            }
          });
        });
        this.input.addEventListener('change', function () { self.sync(); });
        this.sync();
      }

      sync() {
        var value = parseInt(this.input.value, 10) || 0;
        var min = parseInt(this.input.min || '0', 10);
        var max = this.input.max ? parseInt(this.input.max, 10) : null;
        if (this.minus) this.minus.disabled = value <= min;
        if (this.plus) this.plus.disabled = max !== null && value >= max;
      }
    });
  }

  /* ---------------------------------------------------------------
     Product form — AJAX add to cart
     --------------------------------------------------------------- */
  if (!customElements.get('product-form')) {
    customElements.define('product-form', class extends HTMLElement {
      connectedCallback() {
        this.form = this.querySelector('form');
        if (!this.form || theme.cartType === 'page') return;
        this.button = this.form.querySelector('[type="submit"][name="add"]');
        this.errorEl = this.querySelector('[data-form-error]');
        this.form.addEventListener('submit', this.onSubmit.bind(this));
      }

      onSubmit(event) {
        event.preventDefault();
        if (!this.button || this.button.disabled) return;
        var self = this;
        this.setError('');
        this.button.classList.add('is-loading');
        this.button.setAttribute('aria-busy', 'true');

        fetchJSON(routes.cartAdd + '.js', {
          method: 'POST',
          headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: new FormData(this.form)
        })
          .then(function (item) {
            return fetchJSON(routes.cart + '.js', { headers: { Accept: 'application/json' } }).then(function (cart) {
              updateCartCount(cart.item_count);
              document.dispatchEvent(new CustomEvent('cart:added', { detail: { item: item, cart: cart } }));
            });
          })
          .catch(function (error) { self.setError(error.message || strings.cartError); })
          .finally(function () {
            self.button.classList.remove('is-loading');
            self.button.removeAttribute('aria-busy');
          });
      }

      setError(message) {
        if (!this.errorEl) return;
        this.errorEl.textContent = message;
        this.errorEl.hidden = !message;
      }
    });
  }

  /* ---------------------------------------------------------------
     Cart notification popup
     --------------------------------------------------------------- */
  if (!customElements.get('cart-notification')) {
    customElements.define('cart-notification', class extends HTMLElement {
      connectedCallback() {
        var self = this;
        this.onKeyup = function (event) { if (event.key === 'Escape') self.close(); };
        this.onOutside = function (event) { if (!self.contains(event.target)) self.close(); };
        qsa('[data-close]', this).forEach(function (button) {
          button.addEventListener('click', function () { self.close(); });
        });
        document.addEventListener('cart:added', function (event) { self.open(event.detail.item); });
      }

      open(item) {
        var image = this.querySelector('[data-item-image]');
        var title = this.querySelector('[data-item-title]');
        var meta = this.querySelector('[data-item-meta]');
        title.textContent = item.product_title;
        var parts = [];
        if (item.variant_title && !item.product_has_only_default_variant) parts.push(item.variant_title);
        parts.push('× ' + item.quantity);
        meta.textContent = parts.join(' · ');
        if (item.image) {
          var url = new URL(item.image, window.location.origin);
          url.searchParams.set('width', '160');
          image.src = url.toString();
          image.hidden = false;
        } else {
          image.hidden = true;
        }
        this.hidden = false;
        this.focus();
        var self = this;
        setTimeout(function () {
          document.addEventListener('keyup', self.onKeyup);
          document.addEventListener('click', self.onOutside);
        });
      }

      close() {
        this.hidden = true;
        document.removeEventListener('keyup', this.onKeyup);
        document.removeEventListener('click', this.onOutside);
      }
    });
  }

  /* ---------------------------------------------------------------
     Variant picker
     --------------------------------------------------------------- */
  if (!customElements.get('variant-picker')) {
    customElements.define('variant-picker', class extends HTMLElement {
      connectedCallback() {
        var data = this.querySelector('[data-variants]');
        this.variants = data ? JSON.parse(data.textContent) : [];
        this.addEventListener('change', this.onChange.bind(this));
      }

      onChange() {
        var fieldsets = qsa('fieldset', this);
        var selected = fieldsets.map(function (fieldset) {
          var checked = fieldset.querySelector('input:checked');
          var label = fieldset.querySelector('[data-selected-value]');
          if (checked && label) label.textContent = checked.value;
          return checked ? checked.value : null;
        });
        var variant = this.variants.find(function (v) {
          return v.options.every(function (option, index) { return option === selected[index]; });
        });

        var form = document.getElementById(this.dataset.form);
        var idInput = form && form.querySelector('input[name="id"]');
        var button = form && form.querySelector('[data-add-button]');
        var label = button && button.querySelector('[data-add-label]');
        var payment = form && form.querySelector('[data-payment-button]');
        var price = document.querySelector('[data-price="' + this.dataset.section + '"]');

        if (!variant) {
          if (button) button.disabled = true;
          if (label) label.textContent = strings.unavailable;
          if (payment) payment.hidden = true;
          return;
        }

        if (idInput) {
          idInput.value = variant.id;
          idInput.dispatchEvent(new Event('change', { bubbles: true }));
        }
        if (price) price.innerHTML = variant.price_html;
        if (button) button.disabled = !variant.available;
        if (label) label.textContent = variant.available ? strings.addToCart : strings.soldOut;
        if (payment) payment.hidden = !variant.available;

        if (this.dataset.updateUrl === 'true') {
          var url = new URL(window.location.href);
          url.searchParams.set('variant', variant.id);
          window.history.replaceState({}, '', url.toString());
        }

        if (variant.media_id) {
          var gallery = document.querySelector('media-gallery[data-section="' + this.dataset.section + '"]');
          if (gallery && gallery.select) gallery.select(String(variant.media_id));
        }

        document.dispatchEvent(new CustomEvent('variant:change', {
          detail: { productId: this.dataset.productId, variant: variant }
        }));
      }
    });
  }

  /* Keep "Buy now" banners in sync with the selected variant */
  document.addEventListener('variant:change', function (event) {
    var detail = event.detail;
    qsa('[data-cta-product="' + detail.productId + '"]').forEach(function (form) {
      var input = form.querySelector('input[name="id"]');
      var button = form.querySelector('button');
      var priceEl = form.querySelector('[data-cta-price]');
      if (input) input.value = detail.variant.id;
      if (button) button.disabled = !detail.variant.available;
      if (priceEl) priceEl.textContent = detail.variant.price_short;
    });
  });

  /* ---------------------------------------------------------------
     Media gallery (tabs)
     --------------------------------------------------------------- */
  if (!customElements.get('media-gallery')) {
    customElements.define('media-gallery', class extends HTMLElement {
      connectedCallback() {
        this.tabs = qsa('[role="tab"]', this);
        var self = this;
        this.tabs.forEach(function (tab, index) {
          tab.addEventListener('click', function () { self.activate(tab); });
          tab.addEventListener('keydown', function (event) {
            var next = null;
            if (event.key === 'ArrowRight' || event.key === 'ArrowDown') next = self.tabs[(index + 1) % self.tabs.length];
            if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') next = self.tabs[(index - 1 + self.tabs.length) % self.tabs.length];
            if (event.key === 'Home') next = self.tabs[0];
            if (event.key === 'End') next = self.tabs[self.tabs.length - 1];
            if (next) {
              event.preventDefault();
              self.activate(next);
              next.focus();
            }
          });
        });
      }

      select(mediaId) {
        var tab = this.tabs.find(function (t) { return t.dataset.mediaId === mediaId; });
        if (tab) this.activate(tab);
      }

      activate(activeTab) {
        this.tabs.forEach(function (tab) {
          var on = tab === activeTab;
          tab.setAttribute('aria-selected', on ? 'true' : 'false');
          tab.tabIndex = on ? 0 : -1;
          var panel = document.getElementById(tab.getAttribute('aria-controls'));
          if (!panel) return;
          panel.hidden = !on;
          if (!on) {
            qsa('video', panel).forEach(function (video) { video.pause(); });
            qsa('iframe', panel).forEach(function (frame) {
              if (frame.contentWindow) {
                frame.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*');
                frame.contentWindow.postMessage('{"method":"pause"}', '*');
              }
            });
          }
        });
      }
    });
  }

  /* ---------------------------------------------------------------
     Share button
     --------------------------------------------------------------- */
  if (!customElements.get('share-button')) {
    customElements.define('share-button', class extends HTMLElement {
      connectedCallback() {
        var button = this.querySelector('button');
        var status = this.querySelector('[data-share-status]');
        var url = this.dataset.url || window.location.href;
        var title = this.dataset.title || document.title;
        button.addEventListener('click', function () {
          if (navigator.share) {
            navigator.share({ title: title, url: url }).catch(function () {});
            return;
          }
          if (navigator.clipboard) {
            navigator.clipboard.writeText(url).then(function () {
              status.textContent = strings.linkCopied;
              setTimeout(function () { status.textContent = ''; }, 3000);
            });
          }
        });
      }
    });
  }

  /* ---------------------------------------------------------------
     Disclosures: header search + dropdowns
     --------------------------------------------------------------- */
  document.addEventListener('toggle', function (event) {
    var details = event.target;
    if (!(details instanceof HTMLDetailsElement) || !details.open) return;
    if (details.hasAttribute('data-disclosure')) {
      qsa('details[data-disclosure][open]').forEach(function (other) {
        if (other !== details) other.open = false;
      });
      var input = details.querySelector('input[type="search"]');
      if (input) setTimeout(function () { input.focus(); }, 50);
    }
  }, true);

  document.addEventListener('click', function (event) {
    qsa('details[data-disclosure][open]').forEach(function (details) {
      if (!details.contains(event.target)) details.open = false;
    });
  });

  document.addEventListener('keyup', function (event) {
    if (event.key !== 'Escape') return;
    qsa('details[data-disclosure][open]').forEach(function (details) {
      details.open = false;
      var summary = details.querySelector('summary');
      if (summary) summary.focus();
    });
  });

  /* Pre-select saved country in address forms */
  qsa('select[data-default]').forEach(function (select) {
    var value = select.dataset.default;
    if (!value) return;
    Array.prototype.forEach.call(select.options, function (option) {
      if (option.value === value || option.textContent.trim() === value) option.selected = true;
    });
  });

  /* ---------------------------------------------------------------
     Auto-submit (localization selects, cart quantities)
     --------------------------------------------------------------- */
  var submitTimer;
  document.addEventListener('change', function (event) {
    var target = event.target;
    if (target.matches('[data-autosubmit]')) {
      target.form.submit();
      return;
    }
    var cartForm = target.closest('form[data-cart-form]');
    if (cartForm && target.name === 'updates[]') {
      clearTimeout(submitTimer);
      submitTimer = setTimeout(function () {
        var update = cartForm.querySelector('[name="update"]');
        if (cartForm.requestSubmit && update) cartForm.requestSubmit(update); else cartForm.submit();
      }, 450);
    }
  });
})();
